<ion-header>
  <ind-page-title [viewData]="pageTitleData" (onControlClick)="onPageTitleControlClick($event)"></ind-page-title>
</ion-header>

<ion-content>
  <div class="sdr-form">

    <!-- Details -->
    <ind-section-header [viewData]="detailsHeader"></ind-section-header>

    <!-- Customer (inline search via ind-form-field LIST — mirrors IAO).
         expandblue / view-all / show-other route to the full Contact List. -->
    <ind-form-field
      [viewData]="contactFormField"
      (handleAdditionalControls)="onContactFormAdditionalControl($event)"
      (onInputClick)="onCustomerFieldClicked()">
    </ind-form-field>

    <!-- Delivery Address -->
    <div class="sdr-section" [class.sdr-section--invalid]="isDeliveryAddressInvalid && !isAlternateAddressActive && !isAddressDropdownOpen">
      <div class="sdr-section-body" [class.sdr-section-body--no-divider]="isAlternateAddressActive">
        <div class="sdr-section-label sdr-section-label--tight">
          {{ 'DELIVERY_ADDRESS' | translate }}
          <ion-icon class="mandatory-icon"></ion-icon>
        </div>

        <!-- Saved-address mode -->
        <ng-container *ngIf="!isAlternateAddressActive">
          <div class="sdr-value-row"
               [class.sdr-value-row--clickable]="addressOptions.length >= 1"
               (click)="addressOptions.length >= 1 && toggleAddressDropdown()">
            <span class="sdr-value" *ngIf="formState?.deliveryAddressId">{{ formState.deliveryAddressLabel }}</span>
            <span class="sdr-value sdr-value--empty" *ngIf="!formState?.deliveryAddressId">
              {{ (addressOptions.length ? 'SDR_SELECT_DELIVERY_ADDRESS' : 'NO_DELIVERY_ADDRESS') | translate }}
            </span>
            <div class="sdr-value-actions">
              <span class="sdr-badge sdr-badge--primary" *ngIf="isDeliveryAddressPrimary">
                {{ 'ACCOUNT_PRIMARY_CONTACT_NAME' | translate }}
              </span>
              <ion-icon *ngIf="addressOptions.length >= 1"
                        [name]="isAddressDropdownOpen ? 'chevron-up' : 'chevron-down'"
                        class="sdr-chevron-icon"></ion-icon>
            </div>
          </div>
        </ng-container>

        <!-- Free-text (alternate) mode -->
        <ng-container *ngIf="isAlternateAddressActive">
          <!-- 500-char cap is an interim business limit; Dynamics field MaxLength is 4000. Confirm final cap with BA. -->
          <textarea class="sdr-alt-input" rows="2"
                    maxlength="500"
                    [class.sdr-alt-input--error]="isDeliveryAddressInvalid"
                    [placeholder]="'SDR_ALT_ADDRESS_PLACEHOLDER' | translate"
                    [value]="formState.alternateDeliveryAddress"
                    (input)="onAlternateAddressInput($event)"
                    (blur)="onAlternateAddressBlur()"></textarea>
          <!-- Required error directly under the field (no section separator) -->
          <div class="sdr-alt-error" *ngIf="isDeliveryAddressInvalid">{{ 'THIS_IS_A_REQUIRED_FIELD' | translate }}</div>
          <button type="button" class="sdr-alt-back" *ngIf="hasSavedAddresses" (click)="useSavedAddress()">
            <ion-icon name="chevron-back-outline"></ion-icon>{{ 'SDR_USE_SAVED_ADDRESS' | translate }}
          </button>
        </ng-container>
      </div>
      <div class="sdr-section-error" *ngIf="isDeliveryAddressInvalid && !isAlternateAddressActive && !isAddressDropdownOpen">
        {{ 'THIS_IS_A_REQUIRED_FIELD' | translate }}
      </div>
      <!-- Backdrop dismisses the address dropdown on outside click. -->
      <div class="sdr-backdrop" *ngIf="isAddressDropdownOpen && !isAlternateAddressActive" (click)="toggleAddressDropdown()"></div>
      <div class="sdr-dropdown" *ngIf="isAddressDropdownOpen && !isAlternateAddressActive">
        <div class="sdr-dropdown-item"
             *ngFor="let addr of addressOptions; trackBy: trackByOptionId"
             [class.sdr-dropdown-item--selected]="addr.id === formState?.deliveryAddressId"
             (click)="selectAddress(addr)">
          <div class="sdr-dropdown-text">{{ addr.label }}</div>
          <span class="sdr-badge sdr-badge--primary" *ngIf="addr.isPrimary">
            {{ 'ACCOUNT_PRIMARY_CONTACT_NAME' | translate }}
          </span>
        </div>
        <div class="sdr-dropdown-alt" (click)="enableAlternateAddress()">
          <ion-icon name="create-outline"></ion-icon>{{ 'SDR_ENTER_DIFFERENT_ADDRESS' | translate }}
        </div>
      </div>
    </div>

    <!-- Email Address -->
    <div class="sdr-section" [class.sdr-section--invalid]="isEmailInvalid && !isAlternateEmailActive && !isEmailDropdownOpen">
      <div class="sdr-section-body" [class.sdr-section-body--no-divider]="isAlternateEmailActive">
        <div class="sdr-section-label sdr-section-label--tight">
          {{ 'EMAIL_ADDRESS' | translate }}
          <ion-icon class="mandatory-icon" *ngIf="isEmailMandatory"></ion-icon>
        </div>

        <!-- Saved-email mode -->
        <ng-container *ngIf="!isAlternateEmailActive">
          <div class="sdr-value-row"
               [class.sdr-value-row--clickable]="emailOptions.length >= 1"
               (click)="emailOptions.length >= 1 && toggleEmailDropdown()">
            <span class="sdr-value" *ngIf="formState?.emailId">{{ formState.emailLabel }}</span>
            <span class="sdr-value sdr-value--empty" *ngIf="!formState?.emailId">
              {{ (emailOptions.length ? 'SDR_SELECT_EMAIL' : 'NO_EMAIL') | translate }}
            </span>
            <div class="sdr-value-actions">
              <span class="sdr-badge sdr-badge--primary" *ngIf="isEmailPrimary">
                {{ 'ACCOUNT_PRIMARY_CONTACT_NAME' | translate }}
              </span>
              <ion-icon *ngIf="emailOptions.length >= 1"
                        [name]="isEmailDropdownOpen ? 'chevron-up' : 'chevron-down'"
                        class="sdr-chevron-icon"></ion-icon>
            </div>
          </div>
        </ng-container>

        <!-- Free-text (alternate) mode -->
        <ng-container *ngIf="isAlternateEmailActive">
          <input class="sdr-alt-input" type="email"
                 [class.sdr-alt-input--error]="isEmailInvalid || isAlternateEmailInvalid"
                 [placeholder]="'SDR_ALT_EMAIL_PLACEHOLDER' | translate"
                 [value]="formState.alternateEmail"
                 (input)="onAlternateEmailInput($event)"
                 (blur)="onAlternateEmailBlur()" />
          <!-- Invalid-format error (a value is present but malformed) -->
          <div class="sdr-alt-error" *ngIf="isAlternateEmailInvalid">{{ 'SDR_INVALID_EMAIL' | translate }}</div>
          <!-- Required error directly under the field (empty + touched; no separator) -->
          <div class="sdr-alt-error" *ngIf="isEmailInvalid && !isAlternateEmailInvalid">{{ 'THIS_IS_A_REQUIRED_FIELD' | translate }}</div>
          <button type="button" class="sdr-alt-back" *ngIf="hasSavedEmails" (click)="useSavedEmail()">
            <ion-icon name="chevron-back-outline"></ion-icon>{{ 'SDR_USE_SAVED_EMAIL' | translate }}
          </button>
        </ng-container>
      </div>
      <div class="sdr-section-error" *ngIf="isEmailInvalid && !isAlternateEmailActive && !isEmailDropdownOpen">
        {{ 'THIS_IS_A_REQUIRED_FIELD' | translate }}
      </div>
      <!-- Backdrop dismisses the email dropdown on outside click. -->
      <div class="sdr-backdrop" *ngIf="isEmailDropdownOpen && !isAlternateEmailActive" (click)="toggleEmailDropdown()"></div>
      <div class="sdr-dropdown" *ngIf="isEmailDropdownOpen && !isAlternateEmailActive">
        <div class="sdr-dropdown-item"
             *ngFor="let opt of emailOptions; trackBy: trackByOptionId"
             [class.sdr-dropdown-item--selected]="opt.id === formState?.emailId"
             (click)="selectEmail(opt)">
          <div class="sdr-dropdown-text">{{ opt.label }}</div>
          <span class="sdr-badge sdr-badge--primary" *ngIf="opt.isPrimary">
            {{ 'ACCOUNT_PRIMARY_CONTACT_NAME' | translate }}
          </span>
        </div>
        <div class="sdr-dropdown-alt" (click)="enableAlternateEmail()">
          <ion-icon name="create-outline"></ion-icon>{{ 'SDR_ENTER_DIFFERENT_EMAIL' | translate }}
        </div>
      </div>
    </div>

    <!-- Products -->
    <div class="sdr-section">
      <div class="sdr-section-label">
        {{ 'PRODUCTS' | translate }}
        <ion-icon class="mandatory-icon"></ion-icon>
        <span class="sdr-section-count" *ngIf="formState?.products?.length">
          ({{ formState.products.length }})
        </span>
      </div>

      <div class="sdr-product-search-wrap"
           [class.sdr-product-search-wrap--invalid]="isProductsInvalid">
        <ion-icon name="search-outline" class="sdr-search-icon"></ion-icon>
        <input type="text"
               class="sdr-product-search-input"
               [placeholder]="'ADD_PRODUCT' | translate"
               [(ngModel)]="pickerSearchText"
               (focus)="openPicker()"
               (input)="onPickerInput()">
      </div>

      <!-- Backdrop dismisses the picker on outside click. -->
      <div class="sdr-backdrop" *ngIf="isPickerOpen" (click)="closePicker()"></div>

      <div class="sdr-picker-anchor" *ngIf="isPickerOpen">
        <div class="sdr-picker-dropdown">
          <div *ngIf="filteredPickerSkus.length === 0" class="sdr-picker-empty">
            {{ 'NO_PRODUCTS_FOUND' | translate }}
          </div>
          <div *ngFor="let sku of filteredPickerSkus; trackBy: trackById"
               class="sdr-picker-row"
               [class.sdr-picker-row--alreadyAdded]="isSkuInForm(sku.skuId)"
               (click)="onPickerRowClick(sku)">
            <div class="sdr-picker-row-info">
              <span class="sdr-picker-row-name">{{ sku.skuName }}</span>
              <span class="sdr-micro-pill sdr-micro-pill--blue" *ngIf="hasSkuLimit(sku.skuId)">
                {{ getSkuLimitLabel(sku.skuId) }}
              </span>
            </div>
            <ion-icon name="checkmark-circle"
                      class="sdr-picker-row-check"
                      *ngIf="isSkuInForm(sku.skuId)"></ion-icon>
          </div>
        </div>
      </div>

      <!--
        Section-level products hint — red required helper "Add at least one
        product to submit" once touched and still empty. Hidden once at least
        one product is added, or while the picker is open.
      -->
      <div class="sdr-section-error sdr-section-error--inline"
           *ngIf="isProductsInvalid && !isPickerOpen">
        {{ 'SDR_PRODUCTS_REQUIRED' | translate }}
      </div>

      <div class="sdr-grid" *ngIf="formState?.products?.length > 0">
        <div class="sdr-grid-header">
          <div class="sdr-gc sdr-gc-product">{{ 'PRODUCT' | translate }}</div>
          <div class="sdr-gc sdr-gc-qty">{{ 'QUANTITY' | translate }}</div>
          <div class="sdr-gc sdr-gc-action"></div>
        </div>
        <ng-container *ngFor="let product of formState.products; let i = index; trackBy: trackByIndex">
          <div class="sdr-grid-row"
               [class.sdr-grid-row--error]="getQtyErrorKey(product)">
            <div class="sdr-gc sdr-gc-product">
              <span class="sdr-grid-product-name">{{ product.skuName }}</span>
              <span class="sdr-micro-pill sdr-micro-pill--blue" *ngIf="hasSkuLimit(product.skuId)">
                {{ getSkuLimitLabel(product.skuId) }}
              </span>
              <!-- Customer's remaining Manual-Distribution allocation balance
                   (OMNI-59706), when a Customer Allocation record was found.
                   Green (not blue) so it never reads as a duplicate of the
                   static SKU limit chip above when both apply to one line. -->
              <span class="sdr-micro-pill sdr-micro-pill--green" *ngIf="hasAllocationInfo(product)">
                {{ getAllocationLabel(product) }}
              </span>
              <!-- OMNI-62147. Remaining is already on the pill above, and
                   Allocated is just Eligible minus it, so neither is repeated. -->
              <div class="sdr-alloc-details" *ngIf="hasAllocationDetails(product)">
                <span *ngIf="!product.allocationUnlimited">{{ 'ELIGIBLE_QUANTITY' | translate }}: {{ product.allocationEligible }}</span>
                <span *ngIf="getAllocationValidity(product) as validity">
                  {{ 'VALIDITY_PERIOD' | translate }}: {{ validity }}
                </span>
              </div>
            </div>
            <div class="sdr-gc sdr-gc-qty">
              <div class="sdr-stepper">
                <button type="button" class="sdr-stepper-btn"
                        (click)="updateQty(i, -1)"
                        [disabled]="isDecrementDisabled(product)">−</button>
                <input class="sdr-qty-input" type="number" min="0"
                       [value]="product.qty"
                       (change)="onGridQtyInput(i, $event)"
                       (blur)="onGridQtyInput(i, $event)">
                <button type="button" class="sdr-qty-dropdown-btn"
                        (click)="openQtyDropdown($event, i)"
                        [attr.aria-label]="'QUANTITY' | translate">
                  <ion-icon name="chevron-down-outline"></ion-icon>
                </button>
                <button type="button" class="sdr-stepper-btn"
                        (click)="updateQty(i, 1)"
                        [disabled]="isIncrementDisabled(product)">+</button>
              </div>
            </div>
            <div class="sdr-gc sdr-gc-action">
              <button type="button" class="sdr-grid-remove-btn" (click)="removeProduct(i)">
                <ion-icon name="close-outline"></ion-icon>
              </button>
            </div>
          </div>

          <!-- Qty error row (Sample-Drop styling): full-width strip below the
               product row with a warning glyph + message. Covers both
               "outside configured range" (typed out-of-band value) and
               "quantity 0 cannot be submitted". -->
          <div class="sdr-grid-error-row" *ngIf="getQtyErrorKey(product) as qtyErrorKey">
            <ion-icon name="warning-outline"></ion-icon>
            <span>{{ qtyErrorKey | translate }}</span>
          </div>
        </ng-container>
      </div>
    </div>

    <!-- Notes & Attachments (visibility, inputs + mandatory driven by the
         BU_ACTIVITY_GA_NOTES_ATTACHMENTS iO config). Staged notes are read via
         @ViewChild on submit and ride the SDR create batch. -->
    <sdr-notes-section
      [sdrId]="null"
      [existingNotes]="[]"
      [readOnly]="false"
      [showSectionHeader]="false">
    </sdr-notes-section>

  </div>
</ion-content>
